
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/style/index.css'
import  './utils/rem'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import dataV from '@jiaminghi/data-view'
// import './assets/styles/common.scss'

Vue.use(dataV)
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
